<main role="main" class="container-fluid" aria-label="Ticketantrag" [style]="isAllContentHidden ? 'display:none' : ''">
  <div class="row justify-content-center">
    <div class="col-12">
      <div class="frame frame-full">
        <div id="edit-antragTicket" class="content scaffold-edit" role="main" aria-label="Formular">
          <div class="row justify-content-between">
            <div class="col-md-4 col-lg-3">
              <app-sidebar-component
                [antragTicketId]="antragTicketId"
                [allowedTypesForSelection]="selectableAttachmentTypes"
              >
              </app-sidebar-component>
            </div>
            <!--ende: statusmeldung-->

            <!--anfang: form container-->
            <div class="col-md-8 col-lg-9">

              <div>
                <app-antragsteller-card
                  [antragsteller] = "antragTicket?.antragstellerDto"
                ></app-antragsteller-card>
              </div>

              <div class="well well-lg m-4">
                <form [formGroup]="antragTicketForm" id="antragForm"
                      class="form-horizontal form-antragTicket" accept-charset="UTF-8">
                  <!--auswahl antragsteller-->
                  <ng-container *ngIf="!this.readonly">
                    <hr>
                    <div class="row d-flex flex-row align-items-end mb-0">
                      <div class="flex-grow-1 col-md-8 mb-0">
                        <app-custom-select
                          id="schueler"
                          [class]="'sfk-ellipsed-ng-select'"
                          [customFormGroup]="antragTicketForm"
                          placeholder="-"
                          [items]="schuelerList"
                          bindLabel="fullName"
                          bindValue="id"
                          [multiple]="false"
                          [clearable]="false"
                          [label]="''+(this.readonly? '':this.pflichtFeldMarker)+'Ich stelle diesen Antrag für ..'"
                          [readonly] = readonly
                          (onchange)="checkIfVorgaengerExists()"
                          data-cy="schuelerId"
                        ></app-custom-select>
                      </div>
                      <div class="flex-grow-1 col-md-4 ml-1 mb-3" >
                        <input type="button"
                               class="btn btn-secondary btn-add-student"
                               value="{{'SCHUELER-TABLE.ADD_BUTTON'|translate}}"
                               title="{{'SCHUELER-TABLE.ADD_BUTTON'|translate}}"
                               (click)="addSchueler()"
                               data-cy="add-schueler-top"
                        >
                      </div>
                    </div>
                    <div class="row form-text text-muted ms-1 mt-0 mb-3">
                      {{'TICKETDETAIL.MICH_SELBST_INFO'|translate}}
                    </div>
                  </ng-container>
                  <!--anfang: Formular-->
                  <hr>
                  <div class="row">

                    <!--LINKE SEITE-->
                    <div class="col-md-12 col-lg-6">

                      <!--anfang: Antragsteller-->

                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('name', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-name mt-0 mb-0"
                      >
                        <app-custom-input
                          id="name"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('name','STANDARD.NACHNAME')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.NAME_INFO,'STANDARD.CHANGE_IN_PROFILE')"
                          [readonly]="true"
                          data-cy="name"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('vorname', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-vorname mt-0 mb-0"
                      >
                        <app-custom-input
                          id="vorname"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('vorname','STANDARD.VORNAME')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.VORNAME_INFO,'STANDARD.CHANGE_IN_PROFILE')"
                          [readonly]="true"
                          data-cy="vorname"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('strasse', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-strasse mt-0 mb-0">
                        <app-custom-input
                          id="strasse"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('strasse','STANDARD.STRASSE')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.STRASSE_INFO,'STANDARD.CHANGE_IN_PROFILE')"
                          [readonly]="true"
                          noteText="{{ 'STANDARD.STRASSE_NOTE'|translate }}"
                          data-cy="strasse"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('plz', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-plz mt-0 mb-0"
                      >
                        <!-- plz validation omitted because readonly is hardcoded to be true -->
                        <app-custom-input
                          id="plz"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('plz','STANDARD.PLZ')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.PLZ_INFO,'STANDARD.CHANGE_IN_PROFILE')"
                          [readonly]="true"
                          (onchange)="setOrt($event, 'ort')"
                          data-cy="plz"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('ort', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-ort mt-0 mb-0">
                        <app-custom-input
                          id="ort"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('ort','STANDARD.WOHNORT')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.WOHNORT_INFO,'STANDARD.CHANGE_IN_PROFILE')"
                          [readonly]="true"
                          data-cy="ort"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('adresszusatz', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-adresszusatz mt-0 mb-0">
                        <app-custom-input
                          id="adresszusatz"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('adresszusatz','STANDARD.ADRESSZUSATZ')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.ADRESSZUSATZ_INFO,'STANDARD.ADRESSZUSATZ_INFO')"
                          [readonly]="true"
                          data-cy="adresszusatz"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('land', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-land mt-0 mb-0">
                        <app-custom-select
                          id="land"
                          [class]="'sfk-ellipsed-ng-select'"
                          [customFormGroup]="antragTicketForm"
                          [items]="landList"
                          [multiple]="false"
                          [clearable]="false"
                          bindLabel="value"
                          bindValue="name"
                          [label]="getFieldLabelOrTranslate('land','STANDARD.LAND')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.LAND_INFO,'')"
                          [readonly]="true"
                          data-cy="land"
                        ></app-custom-select>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('geburtsdatum', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-geburtsdatum mt-0 mb-0"
                      >
                        <app-custom-input
                          id="geburtsdatum"
                          type="date"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('geburtsdatum','STANDARD.GEBURTSDATUM')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.GEBURTSDATUM_INFO,'STANDARD.CHANGE_IN_PROFILE')"
                          [readonly]="true"
                          data-content="dd.mm.yyyy"
                          [max]="this.today | date:'yyyy-MM-dd'"
                          [min]="this.minDateBirthday | date:'yyyy-MM-dd'"
                          (onchange)="vormundChange()"
                          data-cy="geburtsdatum"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('geschlecht', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-geschlecht mt-0 mb-0">
                        <app-custom-select
                          id="geschlecht"
                          [class]="'sfk-ellipsed-ng-select'"
                          [customFormGroup]="antragTicketForm"
                          placeholder="-"
                          [items]="optionGeschlecht"
                          [multiple]="false"
                          [clearable]="false"
                          bindLabel="name"
                          bindValue="id"
                          [label]="getFieldLabelOrTranslate('geschlecht','STANDARD.GESCHLECHT.TITEL')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.GESCHLECHT_INFO,'STANDARD.GESCHLECHT_INFO')"
                          [readonly]="true"
                          data-cy="geschlecht"
                        ></app-custom-select>
                      </div>
                      <div  *ngIf="fieldConfigService.getFieldFromFieldConfig('email', fieldConfig)?.visible"
                            class="form-group sfk-form-vertical-spacer group-for-email mt-0 mb-0">
                        <app-custom-input
                          id="email"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('email','STANDARD.EMAILADRESSE')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.EMAIL_INFO,'STANDARD.EMAIL_INFO')"
                          [readonly]="readonly"
                          data-cy="email"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="effectivelyVisible.includes('emailSchueler') && fieldConfigService.getFieldFromFieldConfig('emailSchueler', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-name mt-0 mb-0"
                      >
                        <app-custom-input
                          id="emailSchueler"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('emailSchueler','STANDARD.EMAILADRESSE-SCHUELER')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.EMAIL_SCHUELER_INFO,'STANDARD.EMAIL_INFO')"
                          [readonly]="readonly"
                          data-cy="emailSchueler"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="effectivelyVisible.includes('telefonnummer') && fieldConfigService.getFieldFromFieldConfig('telefonnummer', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-name mt-0 mb-0"
                      >
                        <app-custom-input
                          id="telefonnummer"
                          [customFormGroup]="antragTicketForm"
                          [label]="getFieldLabelOrTranslate('telefonnummer','STANDARD.TELEFONNUMMER-SCHUELER')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.TELEFONNUMMER_INFO,'STANDARD.TELEFONNUMMER_INFO')"
                          [readonly]="readonly"
                          [noteText]="translateService.instant('STANDARD.TELEFONNUMMER_VALIDATION_INFO')"
                          data-cy="telefonnummer"
                        ></app-custom-input>
                      </div>

                      <label *ngIf="!allVormundFieldsInvisible" class="checkbox-container sfk-form-vertical-spacer">
                        {{'STANDARD.VORMUND_CHECKBOX_LABEL' | translate}}
                        <input type="checkbox" class="control control-checkbox custom-control-input"
                               id="isVormundCheckboxVisible"
                               name="isVormundCheckboxVisible"
                               (change)="toggleVormundCheckbox($event)"
                               [checked]="this.isVormundCheckboxChecked"
                               [disabled]="readonly || (isAntragstellerYoungerThanMinimumAge)"
                               data-cy="vormundInput"/>
                        <span class="checkmark" data-cy="vormundCheckbox"></span>
                      </label>

                      <!--anfang: Vormund-->
                      <div *ngIf="isVormundCheckboxChecked && !allVormundFieldsInvisible"
                           class="flex-row sub-paragraph pb-2"
                      >
                        <h3>
                          {{getTextbausteinOrTranslate(KeyString.VORMUND_TITLE_TICKET,'STANDARD.VORMUND')}}
                        </h3>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('vormundName', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-vormundName mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vormundName"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vormundName','STANDARD.NACHNAME')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDNAME_INFO,'')"
                            [readonly]="readonly"
                            data-cy="vormundName"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('vormundVorname', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-vormundVorname mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vormundVorname"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vormundVorname','STANDARD.VORNAME')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDVORNAME_INFO,'')"
                            [readonly]="readonly"
                            data-cy="vormundVorname"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('isVormundadresseAbweichend', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-name mt-0 mb-0"
                        >
                          <label class="checkbox-container"  style="margin-bottom:3ch;" [ngClass]="{'form-check-disabled' : readonly, 'form-check-active' : !readonly}">
                            {{'FAHRKOSTEN-DETAIL.VORMUNDADRESSE-ABWEICHEND' | translate}}
                            <input type="checkbox" class="control control-checkbox custom-control-input"
                                   formControlName="isVormundadresseAbweichend"
                                   id="isVormundadresseAbweichend"
                                   name="isVormundadresseAbweichend"
                            >
                            <span class="checkmark" data-cy="isVormundadresseAbweichend"></span>
                          </label>
                        </div>
                        <div *ngIf="effectivelyVisible.includes('vormundStrasse')"
                             class="form-group sfk-form-vertical-spacer group-for-vormundStrasse mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vormundStrasse"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vormundStrasse','STANDARD.STRASSE')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDSTRASSE_INFO,'')"
                            [readonly]="readonly"
                            noteText="Bitte geben Sie die Straße und die Hausnummer an."
                            data-cy="vormundStrasse"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="effectivelyVisible.includes('vormundPlz')"
                             class="form-group sfk-form-vertical-spacer group-for-vormundPlz mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vormundPlz"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vormundPlz','STANDARD.PLZ')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDPLZ_INFO,'')"
                            [readonly]="readonly"
                            (onchange)="setOrt($event, 'vormundOrt')"
                            [maxlength]="getMaxPlzLength('vormundLand')"
                            [pattern]="getPlzPattern('vormundLand')"
                            data-cy="vormundPlz"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="effectivelyVisible.includes('vormundOrt')"
                             class="form-group sfk-form-vertical-spacer group-for-vormundOrt mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vormundOrt"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vormundOrt','STANDARD.WOHNORT')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDORT_INFO,'')"
                            [readonly]="readonly"
                            data-cy="vormundOrt"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="effectivelyVisible.includes('vormundAdresszusatz')"
                             class="form-group sfk-form-vertical-spacer group-for-vormundAdresszusatz mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vormundAdresszusatz"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vormundAdresszusatz','STANDARD.ADRESSZUSATZ')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDADRESSZUSATZ_INFO,'STANDARD.ADRESSZUSATZ_INFO')"
                            [readonly]="readonly"
                            data-cy="vormundAdresszusatz"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="effectivelyVisible.includes('vormundLand')"
                             class="form-group sfk-form-vertical-spacer group-for-vormundLand mt-0 mb-0"
                        >
                          <app-custom-select
                            id="vormundLand"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            [items]="landList"
                            [multiple]="false"
                            [clearable]="false"
                            bindLabel="value"
                            bindValue="name"
                            [label]="getFieldLabelOrTranslate('vormundLand','STANDARD.LAND')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDLAND_INFO,'STANDARD.LAND_INFO')"
                            [readonly]="readonly"
                            (onchange)="this.setPlzPatternValidator('vormundPlz', 'vormundLand')"
                            data-cy="vormundLand"
                          ></app-custom-select>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('vormundGeburtsdatum', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-vormundGeburtsdatum mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vormundGeburtsdatum"
                            type="date"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vormundGeburtsdatum','STANDARD.GEBURTSDATUM')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDGEBURTSTAG_INFO,'STANDARD.GEBURTSDATUM_VORMUND_INFO')"
                            [readonly]="readonly"
                            data-content="dd.mm.yyyy"
                            [max]="this.maxDateVormundGeburtsdatum | date:'yyyy-MM-dd'"
                            [min]="this.minDateBirthday | date:'yyyy-MM-dd'"
                            data-cy="vormundGeburtsdatum"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('vormundGeschlecht', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-vormundGeschlecht mt-0 mb-0">
                          <app-custom-select
                            id="vormundGeschlecht"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            placeholder="-"
                            [items]="optionGeschlecht"
                            [multiple]="false"
                            [clearable]="false"
                            bindLabel="name"
                            bindValue="id"
                            [label]="getFieldLabelOrTranslate('vormundGeschlecht','STANDARD.GESCHLECHT.TITEL')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDGESCHLECHT_INFO,'STANDARD.GESCHLECHT_INFO')"
                            [readonly]="readonly"
                            data-cy="vormundGeschlecht"
                          ></app-custom-select>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('vormundEmail', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-vormundEmail mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vormundEmail"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vormundEmail','STANDARD.EMAIL')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDEMAIL_INFO,'STANDARD.EMAIL_INFO')"
                            [readonly]="readonly"
                            data-cy="vormundEmail"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('vormundTelefonnummer', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-vormundTelefonnummer  mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vormundTelefonnummer"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vormundTelefonnummer','STANDARD.TELEFONNUMMER')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORMUNDTELEFONNUMMER_INFO,'STANDARD.TELEFONNUMMER_INFO')"
                            [readonly]="readonly"
                            [noteText]="translateService.instant('STANDARD.TELEFONNUMMER_VALIDATION_INFO')"
                            data-cy="vormundTelefonnummer"
                          ></app-custom-input>
                        </div>
                      </div>
                      <!--ende: Vormund-->

                      <!--weiter: Antragsteller-->
                      <!--anfang Geschwisterkinder-->
                      <div class="flex-row sub-paragraph pb-2">
                        <h4 class="mt-1 mb-3">
                          {{getTextbausteinOrTranslate(KeyString.INFO_KOSTENBERECHNUNG_TITEL_TICKET,'TICKETDETAIL.INFORMATIONEN_KOSTENBERECHNUNG')}}
                        </h4>

                        <div
                          *ngIf="
                        fieldConfigService.getFieldFromFieldConfig('geschwisterkind1', fieldConfig)?.visible
                        || fieldConfigService.getFieldFromFieldConfig('geschwisterkind2', fieldConfig)?.visible
                        || fieldConfigService.getFieldFromFieldConfig('geschwisterkind3', fieldConfig)?.visible
                        || fieldConfigService.getFieldFromFieldConfig('geschwisterkind4', fieldConfig)?.visible
                        || fieldConfigService.getFieldFromFieldConfig('geschwisterkind5', fieldConfig)?.visible
                        "
                          class="col mt-0 mb-3"
                        >
                          <div  *ngIf="!this.readonly">
                            <input type="button"
                                   class="btn btn-secondary btn-add-student w-100"
                                   value="{{'SCHUELER-TABLE.ADD_BUTTON_PLURAL'|translate}}"
                                   title="{{'SCHUELER-TABLE.ADD_BUTTON_PLURAL'|translate}}"
                                   (click)="addSchueler()"
                                   data-cy="add-schueler-geschwister"
                            >
                          </div>
                        </div>

                        <!--anfang geschwisterkind1-->
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('geschwisterkind1', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-geschwisterkind1 mt-0 mb-0"
                        >
                          <app-custom-select
                            id="geschwisterkind1"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            placeholder="-"
                            [items]="schuelerList"
                            [multiple]="false"
                            bindLabel="fullName"
                            bindValue="id"
                            [label]="getFieldLabelOrTranslate('geschwisterkind1','STANDARD.GESCHWISTERKIND1')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.GESCHWISTERKIND1_INFO,'TICKETDETAIL.GESCHWISTERKIND_INFO')"
                            [readonly]="readonly"
                            (onchange) = setGeschwisterkind(1)
                            data-cy="geschwisterkind1"
                          ></app-custom-select>
                          <div *ngIf=" !(!getFormItem('geschwisterkind1').value) && fieldConfigService.getFieldFromFieldConfig('geschwisterkind1', fieldConfig)?.visible"
                               class="row"
                          >
                          <span>
                            <div class="geschwisterInput-label">Name:</div>
                            <input id="geschwisterkind1name" type="text"
                                   formControlName="geschwisterkind1name"
                                   class="geschwisterInput" readonly="readonly"
                                   [style]="dynamicWidth('geschwisterkind1name')"
                            />,
                            <input id="geschwisterkind1vorname" type="text"
                                   formControlName="geschwisterkind1vorname"
                                   class="geschwisterInput" readonly="readonly"
                                   [style]="dynamicWidth('geschwisterkind1vorname')"
                            />
                          </span>
                            <br>
                            <span>
                            <div class="geschwisterInput-label">Geburtsdatum:</div>
                            <input id="geschwisterkind1geburtsdatum" type="text"
                                   formControlName="geschwisterkind1geburtsdatum"
                                   class="geschwisterInput" readonly="readonly"
                                   [style]="dynamicWidth('geschwisterkind1geburtsdatum')"
                            />
                          </span>
                            <br>
                            <!-- unlike in other places "readonly" is not a variable here, but a constant string -->
                            <span>
                            <div class="geschwisterInput-label">Adresse:</div>
                            <input type="text" id="geschwisterkind1strasse"
                                   formControlName="geschwisterkind1strasse"
                                   class="geschwisterInput" readonly="readonly"
                                   [style]="dynamicWidth('geschwisterkind1strasse')"
                            />,
                            <input type="text" id="geschwisterkind1plz"
                                   formControlName="geschwisterkind1plz"
                                   class="geschwisterInput" readonly="readonly"
                                   [style]="dynamicWidth('geschwisterkind1plz')"
                            />
                            <input type="text" id="geschwisterkind1ort"
                                   formControlName="geschwisterkind1ort"
                                   class="geschwisterInput" readonly="readonly"
                                   [style]="dynamicWidth('geschwisterkind1ort')"
                            />
                          </span>
                            <br>
                            <span>
                            <div class="geschwisterInput-label">Schule:</div>
                            <input type="text" id="geschwisterkind1schule"
                                   formControlName="geschwisterkind1schule"
                                   class="geschwisterInput" readonly="readonly"
                                   [style]="dynamicWidth('geschwisterkind1schule')"
                            />
                          </span>
                          </div>
                        </div>
                        <!--ende geschwisterkind1-->

                        <!--anfang geschwisterkind2-->
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('geschwisterkind2', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-geschwisterkind2  mt-0 mb-0">
                          <app-custom-select
                            id="geschwisterkind2"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            placeholder="-"
                            [items]="schuelerList"
                            bindLabel="fullName"
                            [multiple]="false"
                            bindValue="id"
                            [label]="getFieldLabelOrTranslate('geschwisterkind2','STANDARD.GESCHWISTERKIND2')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.GESCHWISTERKIND2_INFO,'TICKETDETAIL.GESCHWISTERKIND_INFO')"
                            [readonly]="readonly"
                            (onchange) = setGeschwisterkind(2)
                            data-cy="geschwisterkind2"
                          ></app-custom-select>

                          <div *ngIf=" !(!getFormItem('geschwisterkind2').value) && fieldConfigService.getFieldFromFieldConfig('geschwisterkind2', fieldConfig)?.visible"
                               class="row"
                          >
                            <span>
                              <div class="geschwisterInput-label">Name:</div>
                              <input id="geschwisterkind2name" type="text"
                                     formControlName="geschwisterkind2name"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind2name')"
                              />,
                              <input id="geschwisterkind2vorname" type="text"
                                     formControlName="geschwisterkind2vorname"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind2vorname')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Geburtsdatum:</div>
                              <input id="geschwisterkind2geburtsdatum" type="text"
                                     formControlName="geschwisterkind2geburtsdatum"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind2geburtsdatum')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Adresse:</div>
                              <input type="text" id="geschwisterkind2strasse"
                                     formControlName="geschwisterkind2strasse"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind2strasse')"
                              />,
                              <input type="text" id="geschwisterkind2plz"
                                     formControlName="geschwisterkind2plz"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind2plz')"
                              />
                              <input type="text" id="geschwisterkind2ort"
                                     formControlName="geschwisterkind2ort"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind2ort')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Schule:</div>
                              <input type="text" id="geschwisterkind2schule"
                                     formControlName="geschwisterkind2schule"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind2schule')"
                              />
                            </span>
                          </div>
                        </div>
                        <!--ende geschwisterkind2-->

                        <!--anfang geschwisterkind3-->
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('geschwisterkind3', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-geschwisterkind3  mt-0 mb-0"
                        >
                          <app-custom-select
                            id="geschwisterkind3"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            placeholder="-"
                            [items]="schuelerList"
                            bindLabel="fullName"
                            [multiple]="false"
                            bindValue="id"
                            [label]="getFieldLabelOrTranslate('geschwisterkind3','STANDARD.GESCHWISTERKIND3')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.GESCHWISTERKIND3_INFO,'TICKETDETAIL.GESCHWISTERKIND_INFO')"
                            [readonly]="readonly"
                            (onchange) = setGeschwisterkind(3)
                            data-cy="geschwisterkind3"
                          ></app-custom-select>
                          <div *ngIf=" !(!getFormItem('geschwisterkind3').value) && fieldConfigService.getFieldFromFieldConfig('geschwisterkind3', fieldConfig)?.visible"
                               class="row"
                          >
                            <span>
                              <div class="geschwisterInput-label">Name:</div>
                              <input id="geschwisterkind3name" type="text"
                                     formControlName="geschwisterkind3name"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind3name')"
                              />,
                              <input id="geschwisterkind3vorname" type="text"
                                     formControlName="geschwisterkind3vorname"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind3vorname')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Geburtsdatum:</div>
                              <input id="geschwisterkind3geburtsdatum" type="text"
                                     formControlName="geschwisterkind3geburtsdatum"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind3geburtsdatum')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Adresse:</div>
                              <input type="text" id="geschwisterkind3strasse"
                                     formControlName="geschwisterkind3strasse"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind3strasse')"
                              />,
                              <input type="text" id="geschwisterkind3plz"
                                     formControlName="geschwisterkind3plz"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind3plz')"
                              />
                              <input type="text" id="geschwisterkind3ort"
                                     formControlName="geschwisterkind3ort"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind3ort')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Schule:</div>
                              <input type="text" id="geschwisterkind3schule"
                                     formControlName="geschwisterkind3schule"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind3schule')"
                              />
                            </span>
                          </div>
                        </div>
                        <!--ende geschwisterkind3-->

                        <!--anfang geschwisterkind4-->
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('geschwisterkind4', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-geschwisterkind4 mt-0 mb-0"
                        >
                          <app-custom-select
                            id="geschwisterkind4"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            placeholder="-"
                            [items]="schuelerList"
                            bindLabel="fullName"
                            [multiple]="false"
                            bindValue="id"
                            [label]="getFieldLabelOrTranslate('geschwisterkind4','STANDARD.GESCHWISTERKIND4')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.GESCHWISTERKIND4_INFO,'TICKETDETAIL.GESCHWISTERKIND_INFO')"
                            [readonly]="readonly"
                            (onchange) = setGeschwisterkind(4)
                            data-cy="geschwisterkind4"
                          ></app-custom-select>

                          <div *ngIf=" !(!getFormItem('geschwisterkind4').value) && fieldConfigService.getFieldFromFieldConfig('geschwisterkind4', fieldConfig)?.visible"
                               class="row"
                          >
                            <span>
                              <div class="geschwisterInput-label">Name:</div>
                              <input id="geschwisterkind4name" type="text"
                                     formControlName="geschwisterkind4name"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind4name')"
                              />,
                              <input id="geschwisterkind4vorname" type="text"
                                     formControlName="geschwisterkind4vorname"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind4vorname')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Geburtsdatum:</div>
                              <input id="geschwisterkind4geburtsdatum" type="text"
                                     formControlName="geschwisterkind4geburtsdatum"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind4geburtsdatum')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Adresse:</div>
                              <input type="text" id="geschwisterkind4strasse"
                                     formControlName="geschwisterkind4strasse"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind4strasse')"
                              />,
                              <input type="text" id="geschwisterkind4plz"
                                     formControlName="geschwisterkind4plz"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind4plz')"
                              />
                              <input type="text" id="geschwisterkind4ort"
                                     formControlName="geschwisterkind4ort"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind4ort')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Schule:</div>
                              <input type="text" id="geschwisterkind4schule"
                                     formControlName="geschwisterkind4schule"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind4schule')"
                              />
                            </span>
                          </div>
                        </div>
                        <!--ende geschwisterkind4-->

                        <!--anfang geschwisterkind5-->
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('geschwisterkind5', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-geschwisterkind5 mt-0 mb-0"
                        >
                          <app-custom-select
                            id="geschwisterkind5"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            placeholder="-"
                            [items]="schuelerList"
                            bindLabel="fullName"
                            [multiple]="false"
                            bindValue="id"
                            [label]="getFieldLabelOrTranslate('geschwisterkind5','STANDARD.GESCHWISTERKIND5')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.GESCHWISTERKIND5_INFO,'TICKETDETAIL.GESCHWISTERKIND_INFO')"
                            [readonly]="readonly"
                            (onchange) = setGeschwisterkind(5)
                            data-cy="geschwisterkind5"
                          ></app-custom-select>

                          <div *ngIf=" !(!getFormItem('geschwisterkind5').value) && fieldConfigService.getFieldFromFieldConfig('geschwisterkind5', fieldConfig)?.visible"
                               class="row"
                          >
                            <span>
                              <div class="geschwisterInput-label">Name:</div>
                              <input id="geschwisterkind5name" type="text"
                                     formControlName="geschwisterkind5name"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind5name')"
                              />,
                              <input id="geschwisterkind5vorname" type="text"
                                     formControlName="geschwisterkind5vorname"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind5vorname')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Geburtsdatum:</div>
                              <input id="geschwisterkind5geburtsdatum" type="text"
                                     formControlName="geschwisterkind5geburtsdatum"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind5geburtsdatum')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Adresse:</div>
                              <input type="text" id="geschwisterkind5strasse"
                                     formControlName="geschwisterkind5strasse"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind5strasse')"
                              />,
                              <input type="text" id="geschwisterkind5plz"
                                     formControlName="geschwisterkind5plz"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind5plz')"
                              />
                              <input type="text" id="geschwisterkind5ort"
                                     formControlName="geschwisterkind5ort"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind5ort')"
                              />
                            </span>
                            <br>
                            <span>
                              <div class="geschwisterInput-label">Schule:</div>
                              <input type="text" id="geschwisterkind5schule"
                                     formControlName="geschwisterkind5schule"
                                     class="geschwisterInput" readonly="readonly"
                                     [style]="dynamicWidth('geschwisterkind5schule')"
                              />
                            </span>
                          </div>
                        </div>
                        <!--ende geschwisterkind5-->

                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('bezugAsylbewerberleistungsgesetz', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-bezugAsylbewerberleistungsgesetz mt-0 mb-0"
                        >
                          <div class="d-flex flex-row"
                               [ngClass]="{'form-check-disabled' : readonly, 'form-check-active' : !readonly}">
                            <label class="checkbox-container">{{getFieldLabelOrTranslate('bezugAsylbewerberleistungsgesetz', 'TICKETDETAIL.BEZUG_ASYLBEWERBERLEISTUNGSGESETZ')}}
                              <input type="checkbox" class="control control-checkbox custom-control-input"
                                     formControlName="bezugAsylbewerberleistungsgesetz"
                                     id="bezugAsylbewerberleistungsgesetz"
                                     name="bezugAsylbewerberleistungsgesetz"
                              >
                              <span class="checkmark" data-cy="bezugAsylbewerberleistungsgesetz"></span>
                            </label>
                            <fa-icon *ngIf="getTextbausteinOrTranslate(KeyString.ASYL_INFO,'STANDARD.ASYL_INFO')"
                                     class="infoIcon"
                                     [icon]="faInfo"
                                     title="{{getTextbausteinOrTranslate(KeyString.ASYL_INFO,'STANDARD.ASYL_INFO')}}"
                            ></fa-icon>
                          </div>
                        </div>
                        @if(getFormItem('bezugAsylbewerberleistungsgesetz')?.value === true && effectivelyVisible.includes('bezugNachweis')){
                          <div class="form-group sfk-form-vertical-spacer group-for-bezugNachweis mt-0 mb-0">
                            <app-ticket-antrag-sidebar-attachments
                              #bezugNachweis
                              data-cy="bezugNachweisAttachments"
                              [antragTicketId]="antragTicketId"
                              [attachmentTypeFilter]="AttachmentType.BEZUGSNACHWEIS"
                              [deleteable]="(antragTicket?.status === 'ENTWURF')"
                              [appendeable]="(antragTicket?.status === 'ENTWURF')"
                              [required]="effectiveValidators.includes('bezugNachweis')"
                              [label]="fieldConfigService.getFieldLabel('bezugNachweis',fieldConfig,undefined)"
                              [allowedTypesForSelection]="selectableAttachmentTypes"
                            >
                            </app-ticket-antrag-sidebar-attachments>
                          </div>
                        }
                      </div>
                      <!--ende kostenberechnung info-->
                    </div>
                    <!--ende linke Seite-->

                    <!--RECHTE SEITE-->
                    <div class="col-lg-6">

                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('wegtyp', fieldConfig)?.visible && !onlySchulwegAllowed()"
                           class="form-group sfk-form-vertical-spacer group-for-wegtyp mt-0 mb-0"
                      >
                        <app-custom-select
                          id="wegtyp"
                          [class]="'sfk-ellipsed-ng-select'"
                          [customFormGroup]="antragTicketForm"
                          placeholder="-"
                          [multiple]="false"
                          [clearable]="false"
                          [items]="optionWegtyp"
                          bindLabel="name"
                          bindValue="id"
                          [label]="getFieldLabelOrTranslate('wegtyp','TICKETDETAIL.WEGTYP.TITEL')"
                          [infoText]="getTextbausteinOrTranslate(KeyString.WEGTYP_INFO,'STANDARD.WEGTYP_INFO')"
                          [readonly]="readonly"
                          data-cy="wegtyp"
                        ></app-custom-select>
                      </div>

                      @if (listsInitialized) {
                        <app-school-info
                          #schoolInfoComponent
                          [antragId]="antragTicket?.antragId"
                          [existsSessionStorageTextbausteine]="existsSessionStorageTextbausteine"
                          [effectivelyVisible]="effectivelyVisible"
                          [effectiveValidators]="effectiveValidators"
                          [fieldConfig]="fieldConfig"
                          [isEntwurf]="this.antragTicket?.status === TicketAntragStatus.ENTWURF"
                          [wegtyp]="getFormItem('wegtyp')?.value"
                          [minDate]="minDate"
                          [schoolList]="schuleList"
                          [schoolYearList]="filteredSchuljahreList"
                          [classList]="filteredKlassenList"
                          [courseList]="filteredBildungsgangList"
                          [schoolLevelList]="filteredSchoolLevelList"
                          [schoolDaysAWeek]="antragTicket?.schultageJeWoche"
                          [courseDate]="antragTicket?.bildungsgangdatum"
                          (schoolChangeEvent)="schuleChange()"
                          (schoolYearChangeEvent)="schuljahrChange()"
                        ></app-school-info>
                      }

                      <!--Anfang Ticket-->
                      <div class="flex-row sub-paragraph pb-2">

                        <h4 class="mt-1 mb-3">
                          {{getTextbausteinOrTranslate(KeyString.ANGABEN_TICKET_TITEL_TICKET,'TICKETDETAIL.ANGABEN_TICKET_TITEL_TICKET')}}
                        </h4>

                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('abonnementnummerAntrag', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-abonnementnummerAntrag mt-0 mb-0"
                        >
                          <app-custom-input
                            id="abonnementnummerAntrag"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('abonnementnummerAntrag','TICKETDETAIL.ABONNEMENTNUMMER')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.ABONNEMENTNUMMER_INFO,'TICKETDETAIL.ABONNEMENTNUMMER_INFO')"
                            [readonly]="readonly"
                            [noteText]="'Gültige Formate: 7#####, 7######, 7#####-0#, 7######-0#, 7#####-#, 7######-#'"
                            data-cy="abonnementnummerAntrag"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('aboGueltigkeit', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-aboGueltigkeit mt-0 mb-0"
                        >
                          <app-custom-input
                            id="aboGueltigkeit"
                            [type]="this.isMonthSelection? 'month' : 'date'"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('aboGueltigkeit','TICKETDETAIL.ABO_GUELTIGKEIT')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.ABO_GUELTIG_AB_INFO,'TICKETDETAIL.ABO_GUELTIG_AB_INFO')"
                            [noteText]="this.gueltigAbNoteText"
                            [readonly]="this.disableGueltigAb || readonly"
                            data-content="dd.mm.yyyy"
                            [min]="this.minDateTicketGueltigAb | date:this.isMonthSelection? 'yyyy-MM' : 'yyyy-MM-dd'"
                            [max]="this.maxDateTicketGueltigAb | date:this.isMonthSelection? 'yyyy-MM' : 'yyyy-MM-dd'"
                            [pattern]="this.isMonthSelection? '[0-9]{4}-[0-9]{2}' : '[0-9]{4}-[0-9]{2}-[0-9]{2}'"
                            [placeholder]="this.isMonthSelection? 'yyyy-MM' : 'yyyy-MM-dd'"
                            data-cy="aboGueltigkeit"
                          ></app-custom-input>
                          <h6 class="text-warning" *ngIf="this.isMonthSelection
                            && fieldConfigService.getFieldFromFieldConfig('aboGueltigkeitWarntext', fieldConfig)?.visible">
                            {{this.gueltigAbInfoText}}
                          </h6>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('ticketId', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-ticketId mt-0 mb-0"
                        >
                          <app-custom-select
                            id="ticketId"
                            [class]="'sfk-ellipsed-ng-select'"
                            class="flex-grow-1"
                            [customFormGroup]="antragTicketForm"
                            [placeholder]="getPlaceholderForTicketart()"
                            [items]="filteredTicketList"
                            [multiple]="false"
                            [clearable]="false"
                            bindLabel="name"
                            bindValue="id"
                            [label]="getFieldLabelOrTranslate('ticketId','TICKETDETAIL.TICKETART')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.TICKET_INFO,'TICKETDETAIL.TICKETART-INFO')"
                            [readonly]="readonly || !schoolInfoComponent?.getSchoolId()"
                            data-cy="ticket"
                          ></app-custom-select>
                        </div>
                      </div>
                      <!--Ende Ticket -->

                      <!--PRAKTIKUM-->
                      <div *ngIf="getFormItem('wegtyp')?.value === wegtypPRAKTIKUMSWEG || getFormItem('wegtyp')?.value === 'BEIDES'"
                           class="flex-row sub-paragraph pb-2"
                      > <!-- group for Praktikum -->
                        <h4>{{'TICKETDETAIL.PRAKTIKUM.TITEL' |translate }}</h4>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumHinweis', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumHinweis mt-0">
                          <label for="praktikumHinweis">
                            {{getFieldLabelOrTranslate('praktikumHinweis', 'TICKETDETAIL.PRAKTIKUM.HINWEIS')}}
                          </label>
                          <div class="alert alert-warning" id="praktikumHinweis">
                            {{getTextbausteinOrTranslate(KeyString.ANTRAGTICKET_PRAKTIKUM_HINWEIS,'STANDARD.PRAKTIKUM_INFO')}}
                          </div>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumStelle', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-name mt-0 mb-0"
                        >
                          <app-custom-input
                            id="praktikumStelle"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('praktikumStelle','FAHRKOSTEN-DETAIL.PRAKTIKUMSTELLE')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.PRAKTIKUMSTELLE_INFO,'STANDARD.PRAKTIKUMSTELLE_INFO')"
                            [readonly]="readonly"
                            data-cy="praktikumStelle"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumStrasse', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumStrasse mt-0 mb-0"
                        >
                          <app-custom-input
                            id="praktikumStrasse"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('praktikumStrasse','STANDARD.STRASSE')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.PRAKTIKUMSTRASSE_INFO,'')"
                            [readonly]="readonly"
                            noteText="Bitte geben Sie die Straße und die Hausnummer an."
                            data-cy="praktikumStrasse"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumPlz', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumPlz mt-0 mb-0"
                        >
                          <app-custom-input
                            id="praktikumPlz"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('praktikumPlz','STANDARD.PLZ')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.PRAKTIKUMPLZ_INFO,'')"
                            [readonly]="readonly"
                            [maxlength]="getMaxPlzLength('praktikumLand')"
                            [pattern]="getPlzPattern('praktikumLand')"
                            (onchange)="setOrt($event, 'praktikumOrt')"
                            data-cy="praktikumPlz"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumOrt', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumOrt mt-0 mb-0"
                        >
                          <app-custom-input
                            id="praktikumOrt"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('praktikumOrt','STANDARD.ORT')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.PRAKTIKUMORT_INFO,'')"
                            [readonly]="readonly"
                            data-cy="praktikumOrt"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumAdresszusatz', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumAdresszusatz mt-0 mb-0"
                        >
                          <app-custom-input
                            id="praktikumAdresszusatz"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('praktikumAdresszusatz','STANDARD.ADRESSZUSATZ')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.PRAKTIKUMADRESSZUSATZ_INFO,'STANDARD.ADRESSZUSATZ_INFO')"
                            [readonly]="readonly"
                            data-cy="praktikumAdresszusatz"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumLand', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumLand mt-0 mb-0"
                        >
                          <app-custom-select
                            id="praktikumLand"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            [items]="landList"
                            [multiple]="false"
                            [clearable]="false"
                            bindLabel="value"
                            bindValue="name"
                            [label]="getFieldLabelOrTranslate('praktikumLand','STANDARD.LAND')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.PRAKTIKUMLAND_INFO,'STANDARD.LAND_INFO')"
                            [readonly]="readonly"
                            (onchange)="this.setPlzPatternValidator('praktikumPlz', 'praktikumLand')"
                            data-cy="praktikumLand"
                          ></app-custom-select>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumStartdatum', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumStartdatum mt-0 mb-0"
                        >
                          <app-custom-input
                            id="praktikumStartdatum"
                            type="date"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('praktikumStartdatum','TICKETDETAIL.PRAKTIKUM.STARTDATUM')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.PRAKTIKUMSTARTDATUM_INFO,'')"
                            [readonly]="readonly"
                            data-content="dd.mm.yyyy"
                            [min]="this.minDate | date:'yyyy-MM-dd'"
                            data-cy="praktikumStartdatum"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumEnddatum', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumEnddatum mt-0 mb-0"
                        >
                          <app-custom-input
                            id="praktikumEnddatum"
                            type="date"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('praktikumEnddatum','TICKETDETAIL.PRAKTIKUM.ENDDATUM')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.PRAKTIKUMENDDATUM_INFO,'')"
                            [readonly]="readonly"
                            data-content="dd.mm.yyyy"
                            [min]="this.minDatePraktikumEnddatum | date:'yyyy-MM-dd'"
                            data-cy="praktikumEnddatum"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumstageJeWoche', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumstageJeWoche mt-0 mb-0"
                        >
                          <label for="praktikumstageJeWoche">
                            {{getFieldLabelOrTranslate('praktikumstageJeWoche', 'TICKETDETAIL.PRAKTIKUM.PRAKTIKUMSTAGE_JE_WOCHE')}}
                          </label>
                          <fa-icon *ngIf="getTextbausteinOrTranslate(KeyString.PRAKTIKUMSTAGE_JE_WOCHE_INFO,'TICKETDETAIL.PRAKTIKUMSVERTRAG-INFO')"
                                   class="infoIcon"
                                   [icon]="faInfo"
                                   title="{{getTextbausteinOrTranslate(KeyString.PRAKTIKUMSTAGE_JE_WOCHE_INFO,'TICKETDETAIL.PRAKTIKUMSVERTRAG-INFO')}}"
                          ></fa-icon>
                          <br>
                          <input id="praktikumstageJeWoche" type="number" min="0" max="7" class="form-control"
                                 formControlName="praktikumstageJeWoche" [readonly]="readonly"
                                 data-cy="praktikumstageJeWoche"/>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('praktikumsvertrag', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-praktikumsvertrag mt-0 mb-0"
                        >
                          <app-ticket-antrag-sidebar-attachments
                            #praktikumsvertrag
                            [antragTicketId]="antragTicketId"
                            [attachmentTypeFilter]="AttachmentType.PRAKTIKUMSNACHWEIS"
                            [deleteable]="(antragTicket?.status === 'ENTWURF')"
                            [appendeable]="(antragTicket?.status === 'ENTWURF')"
                            [required]="effectiveValidators.includes('praktikumsvertrag')"
                            [label]="fieldConfigService.getFieldLabel('praktikumsvertrag',fieldConfig,undefined)"
                            [allowedTypesForSelection]="selectableAttachmentTypes"
                          >
                          </app-ticket-antrag-sidebar-attachments>
                        </div>
                      </div>
                      <!--ende PRAKTIKUM-->

                      <!--anfang: Fahrweg-Angaben-->
                      <div class="flex-row sub-paragraph pb-2" *ngIf="fieldConfigService.getFieldFromFieldConfig('einstieghaltestelleId', fieldConfig)?.visible || fieldConfigService.getFieldFromFieldConfig('ausstieghaltestelleHinwegId', fieldConfig)?.visible">
                        <h4 class="mt-1 mb-3">
                          {{getTextbausteinOrTranslate(KeyString.ANGABEN_FAHRWEG_TITEL_TICKET,'TICKETDETAIL.ANGABEN_FAHRWEG')}}
                        </h4>

                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('einstieghaltestelleId', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-einstieghaltestelleId mt-0 mb-0"
                        >
                          <app-custom-select
                            id="einstieghaltestelleId"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            [placeholder]="'Bitte mindestens 2 Zeichen eingeben'"
                            [items]="einstiegHaltestelleList"
                            bindLabel="comboName"
                            bindValue="id"
                            [multiple]="false"
                            [clearable]="true"
                            [searchable]="true"
                            [notfoundtext]="'Nichts, gefunden. Bitte mindestens 2 Zeichen eingeben'"
                            [label]="getFieldLabelOrTranslate('einstieghaltestelleId','TICKETDETAIL.EINSTIEGHALTE')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.EINSTIEGHALTESTELLE_INFO,'')"
                            [readonly]="readonly"
                            [loading]="this.einstiegHaltestelleLoading"
                            (onsearch)="this.filterEinstieghaltestelle()"
                            (onScrollToEnd)="this.loadNextPageEinstiegHaltestelle()"
                            data-cy="einstieghaltestelle"
                          ></app-custom-select>
                          <div>
                          <span data-original-title="Im Textbaustein bearbeiten" data-placement="top" rel="tooltip"
                                class="fa fa-info-circle" href="javascript:void(0);"></span>
                          </div>
                        </div>

                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('ausstieghaltestelleHinwegId', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-ausstieghaltestelleHinwegId mt-0 mb-0"
                        >
                          <app-custom-select
                            id="ausstieghaltestelleHinwegId"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            [placeholder]="!schoolInfoComponent?.getSchoolId()?('TICKETDETAIL.INFO_KEINE_SCHULE' |translate):'Bitte mindestens 2 Zeichen eingeben'"
                            [items]="ausstiegHaltestelleList"
                            [multiple]="false"
                            [clearable]="false"
                            bindLabel="comboName"
                            bindValue="id"
                            [label]="getFieldLabelOrTranslate('ausstieghaltestelleHinwegId','TICKETDETAIL.AUSSTIEGHALTE')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.AUSSTIEGHALTESTELLE_INFO,'')"
                            [readonly]="readonly || !schoolInfoComponent?.getSchoolId()"
                            data-cy="ausstieghaltestelleHinweg"
                          ></app-custom-select>
                        </div>
                      </div>
                      <!--ende: fahrweg-->


                      <!--Sonderfall-->
                      <div class="flex-row sub-paragraph pb-2" *ngIf="fieldConfigService.getFieldFromFieldConfig('sonderfall', fieldConfig)?.visible">
                        <h4 class="mt-1 mb-3">
                          {{getTextbausteinOrTranslate(KeyString.ERSTATTUNG_GRUENDE_TITEL_TICKET,'TICKETDETAIL.SONDERFALL.TITEL')}}
                        </h4>

                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('sonderfall', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-sonderfall mt-0 mb-0"
                        >
                          <div class="d-flex flex-row">
                            <div class="flex-grow-1 mr-2">
                              <app-custom-radio id="sonderfall"
                                                [options]="optionSonderfall"
                                                [customFormGroup]="antragTicketForm"
                                                [label]="getFieldLabelOrTranslate('sonderfall','TICKETDETAIL.SONDERFALL.SONDERFAELLE')"
                                                [infoText]="getTextbausteinOrTranslate(KeyString.SONDERFALL_INFO,'STANDARD.SONDERFALL_INFO')"
                                                [infoTextBelowInput]="getInfoTextbausteinOrTranslate(KeyString.SONDERFALL_INFO_BELOW,'')"
                                                [readonly]="readonly"
                                                [ngClass]="{'form-check-input-disabled' : readonly, 'form-check-input-active' : !readonly}"
                                                data-cy="sonderfall"
                              ></app-custom-radio>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="effectivelyVisible.includes('sonderfallBegruendung')"
                             class="form-group sfk-form-vertical-spacer group-for-sonderfallBegruendung mt-0 mb-0"
                        >
                          <div class="d-flex flex-row">
                            <div class="flex-grow-1 mr-2">
                              <app-textarea
                                id="sonderfallBegruendung"
                                [rows]="5"
                                [customFormGroup]="antragTicketForm"
                                [label]="getFieldLabelOrTranslate('sonderfallBegruendung','TICKETDETAIL.SONDERFALL.BEGRUENDUNG')"
                                [infoText]="getTextbausteinOrTranslate(KeyString.SONDERFALLBEGRUENDUNG_INFO,'')"
                                [readonly]="readonly"
                                data-cy="sonderfallBegruendung"
                              ></app-textarea>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="effectivelyVisible.includes('sonderfallNachweis')"
                             class="form-group sfk-form-vertical-spacer group-for-sonderfallNachweis mt-0 mb-0"
                        >
                          <app-ticket-antrag-sidebar-attachments
                            #sonderfallNachweis
                            [antragTicketId]="antragTicketId"
                            [attachmentTypeFilter]="AttachmentType.SONDERFALLNACHWEIS"
                            [deleteable]="(antragTicket?.status === 'ENTWURF')"
                            [appendeable]="(antragTicket?.status === 'ENTWURF')"
                            [required]="effectiveValidators.includes('sonderfallNachweis')"
                            [label]="fieldConfigService.getFieldLabel('sonderfallNachweis',fieldConfig,undefined)"
                            [allowedTypesForSelection]="selectableAttachmentTypes"
                          >
                          </app-ticket-antrag-sidebar-attachments>
                        </div>
                      </div>

                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('referenzFuerZahlungen', fieldConfig)?.visible
                            && antragTicket?.status !== 'ENTWURF' && antragTicket?.status !== 'EINGEREICHT'
                            && antragTicketId && antragTicketId !== ''
                            && antragTicketId !== null"
                           class="mt-0 mb-0"
                      >
                        <div class="d-flex flex-row">
                          <div class="flex-grow-1 mr-2">
                            <app-custom-input id="referenzFuerZahlungen"
                                              [customFormGroup]="antragTicketForm"
                                              [label]="getFieldLabelOrTranslate('referenzFuerZahlungen','TICKETDETAIL.REFERENZZAHLUNG')"
                                              [infoText]="getTextbausteinOrTranslate(KeyString.REFERENZZAHLUNG_INFO,'')"
                                              [readonly]="true"
                                              data-cy="referenzFuerZahlungen"
                            ></app-custom-input>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('bemerkungAntragsteller', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-bemerkungAntragsteller mt-0 mb-0"
                      >
                        <div class="d-flex flex-row">
                          <div class="flex-grow-1 mr-2">
                            <app-textarea
                              [label]="getFieldLabelOrTranslate('bemerkungAntragsteller','TICKETDETAIL.BEMANTRAGSTELLER')"
                              [rows]="5"
                              [customFormGroup]="antragTicketForm"
                              id="bemerkungAntragsteller"
                              [infoText]="getTextbausteinOrTranslate(KeyString.BEMERKUNG_ANTRAGSTELLER_INFO,'TICKETDETAIL.BEMANTRAGSTELLER-INFO')"
                              [readonly]="readonly"
                              data-cy="bemerkungAntragsteller"
                            ></app-textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--ende rechte Seite-->
                  </div>

                  <!--SEPA TEIL-->
                  <hr *ngIf="moduleConfigService.isModuleEnabled('antragTicketSepa')">

                  <div *ngIf="moduleConfigService.isModuleEnabled('antragTicketSepa')" class="row">
                    <legend>
                      {{getTextbausteinOrTranslate(KeyString.ERTEILUNG_SEPA_MANDAT_TITEL_TICKET,'TICKETDETAIL.SEPA.TITEL')}}
                    </legend>
                    <div class="row">
                      <div class="form-group sfk-form-vertical-spacer group-for-isAntragstellerNotMandatsgeber mt-1 mb-1">
                        <div class="custom-control-inline custom-checkbox group-for-isAntragstellerNotMandatsgeber d-flex flex-row "
                             [ngClass]="{'form-check-disabled' : readonly, 'form-check-active' : !readonly}">
                          <label class="checkbox-container">
                            {{''+getFieldLabelOrTranslate('isAntragstellerNotMandatsgeber','TICKETDETAIL.SEPA.ANTRAGSTELLER_NICHT_MANDATSGEBER')}}
                            <input type="checkbox" class="control control-checkbox custom-control-input"
                                   formControlName="isAntragstellerNotMandatsgeber"
                                   id="isAntragstellerNotMandatsgeber"
                                   name="isAntragstellerNotMandatsgeber"
                                   (change)="sepaChange()"
                                   [attr.disabled]="readonly ? true : null"
                            >
                            <span class="checkmark" data-cy="isAntragstellerNotMandatsgeber"></span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <!--ANTRAGSTELLER != MANDATSGEBER-->
                    <div *ngIf="getFormItem('isAntragstellerNotMandatsgeber')?.value" class="row">

                      <!--SEPA LINKS-->
                      <div class="col-md-12 col-lg-6">
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('nameSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-nameSepa mt-0 mb-0"
                        >
                          <app-custom-input
                            id="nameSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('nameSepa','STANDARD.NACHNAME')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.NAMESEPA_INFO,'')"
                            [readonly]="readonly"
                            data-cy="nameSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('vornameSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-vornameSepa mt-0 mb-0"
                        >
                          <app-custom-input
                            id="vornameSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('vornameSepa','STANDARD.VORNAME')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.VORNAMESEPA_INFO,'')"
                            [readonly]="readonly"
                            data-cy="vornameSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('strasseSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-strasseSepa mt-0 mb-0"
                        >
                          <app-custom-input
                            id="strasseSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('strasseSepa','TICKETDETAIL.SEPA.STRASSE')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.STRASSESEPA_INFO,'')"
                            [readonly]="readonly"
                            noteText="Bitte geben Sie die Straße und die Hausnummer an."
                            data-cy="strasseSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('plzSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-plzSepa mt-0 mb-0">
                          <app-custom-input
                            id="plzSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('plzSepa','TICKETDETAIL.SEPA.PLZ')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.PLZSEPA_INFO,'')"
                            [readonly]="readonly"
                            [maxlength]="getMaxPlzLength('landSepa')"
                            [pattern]="getPlzPattern('landSepa')"
                            (onchange)="setOrt($event, 'ortSepa')"
                            data-cy="plzSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('ortSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-ortSepa mt-0 mb-0"
                        >
                          <app-custom-input
                            id="ortSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('ortSepa','TICKETDETAIL.SEPA.ORT')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.ORTSEPA_INFO,'')"
                            [readonly]="readonly"
                            data-cy="ortSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('adresszusatzSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-adresszusatzSepa mt-0 mb-0">
                          <app-custom-input
                            id="adresszusatzSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('adresszusatzSepa','STANDARD.ADRESSZUSATZ')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.ADRESSZUSATZSEPA_INFO,'STANDARD.ADRESSZUSATZ_INFO')"
                            [readonly]="readonly"
                            data-cy="adresszusatzSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('landSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-landSepa mt-0 mb-0"
                        >
                          <app-custom-select
                            id="landSepa"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            [items]="landList"
                            [multiple]="false"
                            [clearable]="false"
                            bindLabel="value"
                            bindValue="name"
                            [label]="getFieldLabelOrTranslate('landSepa','STANDARD.LAND')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.LANDSEPA_INFO,'STANDARD.LAND_INFO')"
                            [readonly]="readonly"
                            (onchange)="this.setPlzPatternValidator('plzSepa', 'landSepa')"
                            data-cy="landSepa"
                          ></app-custom-select>
                        </div>
                      </div>

                      <!--SEPA RECHTS-->
                      <div class="col-md-12 col-lg-6">
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('geburtsdatumSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-geburtsdatumSepa mt-0 mb-0"
                        >
                          <app-custom-input
                            id="geburtsdatumSepa"
                            type="date"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('geburtsdatumSepa','TICKETDETAIL.SEPA.GEBURTSDATUM')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.GEBURTSDATUMSEPA_INFO,'STANDARD.GEBURTSDATUM_KONTO_INFO')"
                            [readonly]="readonly"
                            data-content="dd.mm.yyyy"
                            [max]="this.today | date:'yyyy-MM-dd'"
                            [min]="this.minDateBirthday | date:'yyyy-MM-dd'"
                            data-cy="geburtsdatumSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('geschlechtSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-geschlecht mt-0 mb-0"
                        >
                          <app-custom-select
                            id="geschlechtSepa"
                            [class]="'sfk-ellipsed-ng-select'"
                            [customFormGroup]="antragTicketForm"
                            placeholder="-"
                            [items]="optionGeschlecht"
                            [multiple]="false"
                            [clearable]="false"
                            bindLabel="name"
                            bindValue="id"
                            [label]="getFieldLabelOrTranslate('geschlechtSepa','STANDARD.GESCHLECHT.TITEL')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.GESCHLECHTSEPA_INFO,'STANDARD.GESCHLECHT_INFO')"
                            [readonly]="readonly"
                            data-cy="geschlechtSepa">
                          </app-custom-select>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('emailSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-emailSepa mt-0 mb-0"
                        >
                          <app-custom-input
                            id="emailSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('emailSepa','TICKETDETAIL.SEPA.EMAIL')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.EMAILSEPA_INFO,'STANDARD.EMAIL_INFO')"
                            [readonly]="readonly"
                            data-cy="emailSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('telefonnummerSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-telefonnummerSepa mt-0 mb-0"
                        >
                          <app-custom-input
                            id="telefonnummerSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('telefonnummerSepa','TICKETDETAIL.SEPA.TELEFONNUMMER')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.TELEFONNUMMERSEPA_INFO,'STANDARD.TELEFONNUMMER_INFO')"
                            [readonly]="readonly"
                            [noteText]="translateService.instant('STANDARD.TELEFONNUMMER_VALIDATION_INFO')"
                            data-cy="telefonnummerSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('nameKreditinstitutSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-nameKreditinstitutSepa mt-0 mb-0"
                        >
                          <app-custom-input
                            id="nameKreditinstitutSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('nameKreditinstitutSepa','TICKETDETAIL.SEPA.KREDITINSTITUT_SEPA')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.KREDITINSTITUTSEPA_INFO,'')"
                            [readonly]="readonly"
                            data-cy="nameKreditinstitutSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('ibanSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-ibanSepa mt-0 mb-0"
                        >
                          <app-custom-input
                            id="ibanSepa"
                            [customFormGroup]="antragTicketForm"
                            [label]="getFieldLabelOrTranslate('ibanSepa','TICKETDETAIL.SEPA.IBAN_SEPA')"
                            [infoText]="getTextbausteinOrTranslate(KeyString.SEPAIBAN_INFO,'')"
                            [readonly]="readonly"
                            data-cy="ibanSepa"
                          ></app-custom-input>
                        </div>
                        <div *ngIf="fieldConfigService.getFieldFromFieldConfig('bicSepa', fieldConfig)?.visible"
                             class="form-group sfk-form-vertical-spacer group-for-bicSepa mt-0 mb-0"
                        >
                          <app-custom-input id="bicSepa"
                                            [customFormGroup]="antragTicketForm"
                                            [label]="getFieldLabelOrTranslate('bicSepa','TICKETDETAIL.SEPA.BIC_SEPA')"
                                            [infoText]="getTextbausteinOrTranslate(KeyString.SEPABIC_INFO,'STANDARD.BIC_INFO')"
                                            [readonly]="readonly"
                                            data-cy="bicSepa"
                          ></app-custom-input>
                        </div>
                      </div>
                    </div>

                    <!--ANTRAGSTELLER == MANDATSGEBER-->
                    <div *ngIf="!(getFormItem('isAntragstellerNotMandatsgeber')?.value)" class="col-md-12 col-lg-6">
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('nameKreditinstitut', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-nameKreditinstitut mt-0 mb-0"
                      >
                        <app-custom-input id="nameKreditinstitut"
                                          [customFormGroup]="antragTicketForm"
                                          [label]="getFieldLabelOrTranslate('nameKreditinstitut','TICKETDETAIL.SEPA.KREDITINSTITUT')"
                                          [infoText]="getTextbausteinOrTranslate(KeyString.NAMEKREDITINSTITUT_INFO,'')"
                                          [readonly]="readonly"
                                          data-cy="nameKreditinstitut"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('iban', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-iban mt-0 mb-0"
                      >
                        <app-custom-input id="iban"
                                          [customFormGroup]="antragTicketForm"
                                          [label]="getFieldLabelOrTranslate('iban','TICKETDETAIL.SEPA.IBAN')"
                                          [infoText]="getTextbausteinOrTranslate(KeyString.IBAN_INFO,'')"
                                          [readonly]="readonly"
                                          data-cy="iban"
                        ></app-custom-input>
                      </div>
                      <div *ngIf="fieldConfigService.getFieldFromFieldConfig('bic', fieldConfig)?.visible"
                           class="form-group sfk-form-vertical-spacer group-for-iban mt-0 mb-0"
                      >
                        <app-custom-input id="bic"
                                          [customFormGroup]="antragTicketForm"
                                          [label]="getFieldLabelOrTranslate('bic','TICKETDETAIL.SEPA.BIC')"
                                          [infoText]="getTextbausteinOrTranslate(KeyString.BIC_INFO,'STANDARD.BIC_INFO')"
                                          [readonly]="readonly"
                                          data-cy="bic"
                        ></app-custom-input>
                      </div>
                    </div>
                    @if (fieldConfigService.getFieldFromFieldConfig('datenschutz', fieldConfig)?.visible) {
                      <app-custom-checkbox
                        [id]="'datenschutz'"
                        [customFormGroup]="antragTicketForm"
                        [label]="getFieldLabelOrTranslate('datenschutz','TICKETS.MANDATE_HOLDER_INFORMATION.SEPA_MANDATE_ACCEPTED')"
                        [title]="'TICKETS.MANDATE_HOLDER_INFORMATION.SEPA_MANDATE_TITLE' | translate"
                      ></app-custom-checkbox>
                    }
                    @if (fieldConfigService.getFieldFromFieldConfig('vertragsbedingungen', fieldConfig)?.visible) {
                      <app-custom-checkbox
                        [id]="'vertragsbedingungen'"
                        [customFormGroup]="antragTicketForm"
                        [label]="getFieldLabelOrTranslate('vertragsbedingungen','TICKETDETAIL.SEPA.VERTRAGSBEDINGUNGEN')"
                      ></app-custom-checkbox>
                    }
                  </div>
                  <!-- ende SEPA TEIL-->

                  <hr>

                  <!--finally-->
                  @if (fieldConfigService.getFieldFromFieldConfig('richtigkeitDerAngaben', fieldConfig)?.visible) {
                    <app-custom-checkbox
                      [id]="'richtigkeitDerAngaben'"
                      [customFormGroup]="antragTicketForm"
                      [label]="getFieldLabelOrTranslate('richtigkeitDerAngaben','TICKETDETAIL.RICHTIGKEIT_DER_ANGABEN')"
                    ></app-custom-checkbox>
                  }

                  @if (fieldConfigService.getFieldFromFieldConfig('angabenKorrekt', fieldConfig)?.visible) {
                    <app-custom-checkbox
                      [id]="'angabenKorrekt'"
                      [customFormGroup]="antragTicketForm"
                      [label]="getFieldLabelOrTranslate('angabenKorrekt','TICKETDETAIL.ANGABEN_KORREKT')"
                    ></app-custom-checkbox>
                  }

                  @if (isAntragstellerUnderage === true && fieldConfigService.getFieldFromFieldConfig('zustimmungGesetzlicherVertreter', fieldConfig)?.visible) {
                    <app-custom-checkbox
                      [id]="'zustimmungGesetzlicherVertreter'"
                      [customFormGroup]="antragTicketForm"
                      [label]="getFieldLabelOrTranslate('zustimmungGesetzlicherVertreter','TICKETDETAIL.ZUSTIMMUNG_GESETZLICHER_VERTRETER')"
                    ></app-custom-checkbox>
                  }

                  @if (fieldConfigService.getFieldFromFieldConfig('marketingfreigabe', fieldConfig)?.visible) {
                    <app-custom-checkbox
                      [id]="'marketingfreigabe'"
                      [customFormGroup]="antragTicketForm"
                      [label]="getFieldLabelOrTranslate('marketingfreigabe','TICKETDETAIL.MARKETINGFREIGABE')"
                    ></app-custom-checkbox>
                  }

                  @if (fieldConfigService.getFieldFromFieldConfig('einverstaendnisErklaerung', fieldConfig)?.visible) {
                    <app-custom-checkbox
                      [id]="'einverstaendnisErklaerung'"
                      [customFormGroup]="antragTicketForm"
                      [label]="getFieldLabelOrTranslate('einverstaendnisErklaerung','TICKETDETAIL.EINVERSTAENDNISERKLAERUNG')"
                    ></app-custom-checkbox>
                  }

                  <!--BUTTONS-->
                  <div class="d-flex flex-row-reverse">
                    <input *ngIf="isDeleteDraftButtonVisible" type="button" value="Entwurf löschen"
                           class="btn btn-secondary save btn-block" (click)="deleteDraft()"
                           data-cy="deleteDraft">
                    <span style="width: 1em"></span>
                    <input *ngIf="isUpdateEntwurfButtonVisible" type="button" value="Entwurf speichern"
                           class="btn btn-secondary save btn-block"
                           (click)="saveOrUpdate(draftStatus,'Entwurf wurde erfolgreich gespeichert.', 'ticket-detail')"
                           data-cy="saveOrUpdate">
                    <span style="width: 1em"></span>
                    <input *ngIf="isEinreichenButtonVisible" type="button" value="Antrag einreichen"
                           class="btn btn-primary save btn-block"
                           (click)="saveOrUpdate(eingereichtStatus,'Antrag wurde erfolgreich eingereicht.','ticket-table')"
                           data-cy="antragEinreichen">
                  </div>

                </form>
              </div>
            </div>
            <!--ende: form container-->
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<ngx-spinner
  [color]="'var(--spinner-color)'"
  [bdColor]="'var(--spinner-bd-color)'"
  size="medium"
  type="ball-scale-multiple"
  [fullScreen] = "true"
>
</ngx-spinner>
